import './logo.css';

export default function Logo() {
    return (
        <a href="/">
            <div className="logo__container">
               <img className="logo__photo" src={"/photos/logo/BIMAFI_logo.png"} />
            </div>
        </a>
    );
}